import { createSlice } from "@reduxjs/toolkit";
import produce from "immer";

export const authorSlice = createSlice({
    name: 'Author',
    initialState:{
        user: {},
        products: [
            // {
            //     id: 'A45-B23',
            //     title: 'The Dreaming Arts',
            //     cover: 'https://99designs-blog.imgix.net/blog/wp-content/uploads/2017/02/attachment_80004080-e1488217702832.jpg?auto=format&q=60&fit=max&w=930',
            //     price: {hardCover: 230, standard: 205},
            //     reviews: [
            //         {message: 'This Book is Amazing', status: 'pending', date: '25 July, 2021'},
            //         {message: 'Just OK', status: 'approved', date: '01 Aug, 2021'},
            //         {message: 'Did not like', status: 'rejected', date: ' 11 Aug, 2021'}
            //     ]
            // }
        ],
        earnings:[
            {
                id: 'D2P9654',
                title: 'The Dreaming Arts',
                date: '25 July, 2021',
                amount: 430
            },
            {
                id: 'D2P5478',
                title: 'The Coming Clean',
                date: '3 August, 2021',
                amount: 370
            }
        ],
        orders: [
            {
                id: 'D2P9654',
                title: 'The Dreaming Arts',
                user: 'Qasim M. Asif',
                address: 'Street ABC, Area XYS',
                type: 'Hard Cover',
                price: 230,
                status: 'Delivered',
                date: '25 July, 2021'
            },
            {
                id: 'D2P5478',
                title: 'The Coming Clean',
                user: 'Brown Rathorer',
                address: 'Street ABC, Area XYS',
                type: 'E-Book',
                price: 370,
                status: 'Requested',
                date: '3 August, 2021'
            }
        ],
        notifications:[
            // {
            //     title: 'Order Received',
            //     message: 'Order No. D2P9006 received  by mqasim23',
            //     date: '14 Aug, 2021'
            // },
            // {
            //     title: 'Book Rejectted',
            //     message: 'Book HappyGoLucky Rejected by Review Panel ',
            //     date: '01 Aug, 2021'
            // }
        ]

    },
    reducers: {
        fetchAuthor: (state, action) => {
            console.log("Fetch Author Action Payload:", action.payload);
            // console.log({'Fetch Author Action Payload': action.payload})
            state.user = action.payload
            
        },
        
        updateBook: (state, action) => {
            
        },
        changeReviewStatus: (state, action) => {
            
        }
    }
})

export const {updateBook, changeReviewStatus, fetchAuthor} = authorSlice.actions
export default authorSlice.reducer